export enum AlgorithmLaunchType {
    Automatic = 1,
    Manual = 2,
    AutomaticAndManual = 3
}